module.exports = __webpack_public_path__ + "static/media/selfie-doodle@3x.e1ebd3f9.png";